var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 37,
    viewBox: "0 0 8 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.64645 36.3536C3.84171 36.5488 4.15829 36.5488 4.35355 36.3536L7.53554 33.1716C7.7308 32.9763 7.7308 32.6597 7.53554 32.4645C7.34027 32.2692 7.02369 32.2692 6.82843 32.4645L4 35.2929L1.17157 32.4645C0.976312 32.2692 0.65973 32.2692 0.464468 32.4645C0.269205 32.6597 0.269205 32.9763 0.464468 33.1716L3.64645 36.3536ZM3.5 2.18557e-08L3.5 36L4.5 36L4.5 -2.18557e-08L3.5 2.18557e-08Z",
    fill: "white",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.f9909262e82b14e77205c3836c97edea.svg";
export { ForwardRef as ReactComponent };